import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = props => {
  const {
    item,
    setItem,
    options,
    filterLabel,
    fromDate = "",
    toDate = "",
    setFromDate = () => {},
    setToDate = () => {},
    showToDate = true,
    setFiltersData = () => {},
  } = props
  const handleSubmit = e => {
    e.preventDefault()
    setFiltersData({
      item: item,
      fromDate: fromDate,
      toDate: toDate,
    })
  }
  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>

          <div className="row mb-4">
            <Col lg={4}>
              <Label htmlFor="horizontal-firstname-Input">From</Label>
              <Input
                type="date"
                className="form-control"
                id="horizontal-firstname-Input"
                onChange={e => {
                  setFromDate(e.target.value)
                }}
                value={fromDate}
              />
            </Col>
            <Col lg={4}>
              <Label htmlFor="horizontal-firstname-Input">To</Label>
              <Input
                type="date"
                className="form-control"
                id="horizontal-firstname-Input"
                onChange={e => {
                  setToDate(e.target.value)
                }}
                value={toDate}
              />
            </Col>
            <Col lg={4} className="d-flex flex-column justify-content-end">
              <Button type="submit" color="primary" className="w-md"
                      onClick={() => {
                        props.call()
                      }}
              >
                Submit
              </Button>
            </Col>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  )
}
